import { render, staticRenderFns } from "./SafetyInspectionLogDetails.vue?vue&type=template&id=16f94af8"
import script from "./SafetyInspectionLogDetails.vue?vue&type=script&lang=js"
export * from "./SafetyInspectionLogDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports